import { rest } from 'utils';

export default {
  getTokenAndProducts: () => rest.post({ url: '/ad-server/sessions/new', baseUrl: 'adServer' }),
};
